import React, { useEffect, useState, useRef } from 'react'
import "./AddPassengers.css"
import { Box, Button, calcs, CheckBox, Form, FormField, RadioButtonGroup, Select, Text, TextInput } from 'grommet'
import { Input } from 'rsuite'
import { RootStore } from '../../../../../../store/RootStore'
import { useStore } from '../../../../../../Hooks/useStore'
import { observer } from 'mobx-react'
import PassengerService from '../../../../../../services/passenger/passenger.service'
import { Mixpanel } from '../../../../../../util/Helper'
import { Navigate, useNavigate } from 'react-router-dom'
import backArrow from '../../../../../../assets/arrow_back.svg';


const AddPassengers = observer(() => {
  const { rootStore } = useStore();
  const navigate = useNavigate();
  const [formSubmitted, setFormSubmitted] = useState(false);

  const prevAgeRef = useRef(rootStore.passengerStore.getPassengerAge || '');

  const ChangeStateForm = async () => {
    const emailRegex = /^[a-zA-Z0-9][a-zA-Z0-9._-]*[a-zA-Z0-9]@[a-zA-Z0-9][a-zA-Z0-9.-]*[a-zA-Z0-9]\.[a-zA-Z]{2,}$/;
    // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    // Destructure passengerData for easier readability
    if (!rootStore.passengerStore.getSelectedOrgId1) {
      rootStore.notificationToastStore.showNotification('Please select organization.', true);
      return;
    } else if (!rootStore.passengerStore.getPassengersGender) {
      rootStore.notificationToastStore.showNotification('Please enter gender.', true);
      return;
    } else if (!rootStore.passengerStore.getPassengersName) {
      rootStore.notificationToastStore.showNotification('Please enter passenger name.', true);
      return;
    } else if (!rootStore.passengerStore.getPassengerAge) {
      rootStore.notificationToastStore.showNotification('Please enter passenger age.', true);
      return;
    }  
    // else if (!rootStore.passengerStore.getPassengersContactNumber) {
    //   rootStore.notificationToastStore.showNotification('Please enter passenger contact number.', true);
    //   return;
    // }  
    else if (!emailRegex.test(rootStore.passengerStore.getPassengerEmail)) {
      rootStore.notificationToastStore.showNotification('Please enter valid email.', true);
      return;
    } else {
      rootStore.passengerStore.handlChangeForm(false);
    }
  }


  const onFormSubmit = async () => {
    const uInfo = localStorage.getItem("userinfo");
    const userInformation = JSON.parse(uInfo);
    // Track the event
    Mixpanel.track("web_add_passenger", { name: userInformation.name });
    
    const passengerData = {
      orgId: rootStore.passengerStore.getSelectedOrgId1,
      name: rootStore.passengerStore.getPassengersName,
      // contactNumber: rootStore.passengerStore.getPassengersContactNumber,
      email: rootStore.passengerStore.getPassengerEmail,
      age: rootStore.passengerStore.getPassengerAge,
      address: rootStore.passengerStore.getPassengerAddress,
      gender: rootStore.passengerStore.getPassengersGender.toUpperCase()
    }


    try {
      let passengerRes = await PassengerService.addPassenger(passengerData);
        const passengerMedicalHistory = {
          queAns: {
              3: rootStore.passengerStore.getPassengerAnyChronicDisease1 || "NO",
              4: rootStore.passengerStore.getPassengerPhysicallyDisabledtxt || "NO",
              5: rootStore.passengerStore.getPassengerInput00 || "NO",
              ...(rootStore.passengerStore.getPassengerInput2 ? {6: rootStore.passengerStore.getPassengerInput2} : {}),
              ...(rootStore.passengerStore.getPassengerInput3 ? {7: rootStore.passengerStore.getPassengerInput3} : {}),
              8: rootStore.passengerStore.getPassengerInput4 || "NO",
              9: rootStore.passengerStore.getPassengerInput05 || "NO",
              10: rootStore.passengerStore.getPassengerInput06 || "NO"
          },
          passengerId: passengerRes.id
        }

        await PassengerService.addAnswere(passengerMedicalHistory);
        rootStore.notificationToastStore.showNotification("Passenger added successfully", false, 3000);
        rootStore.passengerStore.handleupdate();
        setFormSubmitted(true);
        navigate("/passengers");
    } catch (error) {
      rootStore.notificationToastStore.showNotification("Passenger not added ,somthing is wrong!", true);
      console.error(error);
    }

  };


  useEffect(() => {
    (async () => {
      let organizations = await PassengerService.getOrganizations();
      rootStore.passengerStore.handleCreatePassengerOrgList1(organizations);
      let uTnfo = localStorage.getItem("userinfo");
      let passengerInformation = JSON.parse(uTnfo);
      rootStore.passengerStore.handlePassengerLabel(passengerInformation.roleLabel)
      if (passengerInformation.roleLabel.toLowerCase() == "admin") {
        console.log("uTnfo",passengerInformation.username);
        let passengerOrg = await PassengerService.getOrgByUserName(passengerInformation.username);
        rootStore.passengerStore.handleSelectedOrgId1(passengerOrg.id)
      }
    })(); // Immediately invoke the async function

    getQuestion();

  }, []);
  useEffect(() => {
    // rootStore.passengerStore.handleSelectedOrgId1('');
    // rootStore.passengerStore.handlePassengersGenger('');

    if (formSubmitted) {
      onclose()
      // Reset form state here
      rootStore.passengerStore.handlePassengersName('');
      rootStore.passengerStore.handlePassengersContactNumber('');
      rootStore.passengerStore.handlePassengerEmail('');
      rootStore.passengerStore.handlePassengerAge('');
      rootStore.passengerStore.handlePassengerAddress('');
      rootStore.passengerStore.handleSelectedOrgId1('');
      rootStore.passengerStore.handlePassengersGenger('');
      rootStore.passengerStore.handlePassengerAnyChronicDisease(false);
      rootStore.passengerStore.handlePassengerAnyChronicDisease1('');
      rootStore.passengerStore.handlePassengerPhysicallyDisabled('');
      rootStore.passengerStore.handlePassengerInput0(false);
      rootStore.passengerStore.handlePassengerInput00('');
      // rootStore.passengerStore.handlePassengerInput1('');
      rootStore.passengerStore.handlePassengerInput2('');
      rootStore.passengerStore.handlePassengerInput3('');
      rootStore.passengerStore.handlePassengerInput4('');
      rootStore.passengerStore.handlePassengerInput5(false);
      rootStore.passengerStore.handlePassengerInput05('');
      rootStore.passengerStore.handlePassengerInput6(false);
      rootStore.passengerStore.handlePassengerInput06('');
      setFormSubmitted(false); // Reset formSubmitted flag
    }

    return;
  }, [formSubmitted]);

  const getQuestion = async () => {
    try {
      let response = await PassengerService.getQuestionList();
      console.table(response);
    } catch(error) {
      console.log("getQuestion" , error);
    }
  }

  useEffect(() => {
    return () => {
      rootStore.passengerStore.handleSelectedOrgId1("");
      rootStore.passengerStore.handlePassengersGenger('');
    }
  },[])

  // --- AGE input helpers ---
  const handleAgeKeyDown = (evt) => {
    // Allow control/meta keys
    if (evt.ctrlKey || evt.metaKey || evt.altKey) return;
    const allowedKeys = ['Backspace','Delete','ArrowLeft','ArrowRight','Home','End','Tab'];
    if (allowedKeys.includes(evt.key)) return;

    // Only allow single digit keys
    if (!/^[0-9]$/.test(evt.key)) {
      evt.preventDefault();
    }
  };

  const handleAgeChange = (e) => {
    const raw = e.target.value || '';
    // remove non-digits
    const digits = raw.replace(/\D/g, '');

    if (digits === '') {
      // empty input allowed (user might be clearing)
      rootStore.passengerStore.handlePassengerAge('');
      prevAgeRef.current = '';
      return;
    }

    // Remove leading zeros by parsing number
    const numeric = parseInt(digits, 10);
    if (isNaN(numeric)) {
      // revert to previous valid value
      rootStore.passengerStore.handlePassengerAge(prevAgeRef.current || '');
      return;
    }

    // If numeric > 120, revert to previous valid value (do not accept)
    if (numeric > 120) {
      // keep previous valid value (prevents entering >120)
      rootStore.passengerStore.handlePassengerAge(prevAgeRef.current || '');
      return;
    }

    // Accept the numeric value (no leading zeros)
    const newVal = String(numeric);
    rootStore.passengerStore.handlePassengerAge(newVal);
    prevAgeRef.current = newVal;
  };

  const handleAgePaste = (e) => {
    e.preventDefault();
    const paste = (e.clipboardData || window.clipboardData).getData('text') || '';
    const digits = paste.replace(/\D/g, '');
    if (!digits) return;

    const numeric = parseInt(digits, 10);
    if (isNaN(numeric) || numeric > 120) {
      // ignore paste if invalid or >120
      return;
    }

    const newVal = String(numeric);
    rootStore.passengerStore.handlePassengerAge(newVal);
    prevAgeRef.current = newVal;
  };
  // --- end AGE helpers ---

  const [emailError, setEmailError] = useState('');
  return (
    <>
    <div className='passenger-header'>
        <div className='header-text-1'><img src={backArrow} onClick={() => rootStore.passengerStore.getChangeForm ? navigate("/passengers") : rootStore.passengerStore.handlChangeForm(true)} alt='back arrow button' />Add Passenger’s Details</div>
        <div className='header-text-1 italic'>{rootStore.passengerStore.getChangeForm ?  "**Demographics**" : "**Medical History**"}</div>
    </div>
    <Box className="add-passengers-container"
    >
      {
        rootStore.passengerStore.getChangeForm ? (
          <Form validate="change" onChange={() => {}} className='middle-container'>
            <Box className='middle-form-box'>
              <div style={{width: 'calc(100% - 200px)'}}>
              <FormField className="add-passenger-form-F1">
                <div className="add-user-modal-form-L7"
                  style={{ width: "100%" }}>
                  <label className="add-passenger-form-L1">
                    Organization
                  </label>
                  <div
                    style={{ width: "100%" }}
                    className={rootStore.passengerStore.getPassengerLabel.toLowerCase() == "admin" ? "create-user-org-outer" : "add-user-sadmin"}>
                    <Select
                      placeholder="Select Organization"
                      style={{
                        width: "100%"

                      }}
                      name="organization"
                      labelKey={"label"}
                      defaultValue={"Select"}
                      valueKey={{ key: "value", reduce: true }}
                      options={rootStore.passengerStore.getCreatePassengerOrgList1.map((org) => {
                        return {
                          label: org.name,
                          value: org.id,
                        };
                      })}
                      value={rootStore.passengerStore.getSelectedOrgId1}
                      // value={newFlight.organization}
                      // defaultValue={""}
                      onChange={(event) => {
                        if (rootStore.passengerStore.getPassengerLabel.toLowerCase() != "admin") {
                          rootStore.passengerStore.handleSelectedOrgId1(event.option.value);
                        }
                      }}
                    />
                  </div>
                </div>
              </FormField>
              <div style={{width: '30%'}}>
                <FormField className="add-passenger-form-F1 check-radio">
                  <label className="add-passenger-form-L1" style={{ marginBottom: 16 }}>Passenger’s Gender</label>
                  <RadioButtonGroup
                    name="doc"
                    options={['MALE', 'FEMALE', "OTHERS"]}
                    value={rootStore.passengerStore.getPassengersGender}
                    onChange={(event) => rootStore.passengerStore.handlePassengersGenger(event.target.value.toUpperCase())}
                    className="form-group"
                  />
                </FormField>
              </div>
              <Box className='middle-form-flex'>
                <FormField
                  className="add-passenger-form-F1"
                  name="passengerName"
                  htmlFor="passenger-name-id"
                  placeholder="Passenger’s Name"
                  validate={[
                    {
                      regexp: /^[a-zA-Z\s]+$/, 
                      message: "Passenger’s name can only contain letters and spaces.",
                    }
                  ]}
                >
                  <label className="add-passenger-form-L1">
                    Passenger’s Name<span>*</span>
                  </label>
                  <TextInput
                    required
                    type="text"
                    className="add-passenger-form-I2"
                    placeholder="Enter Here"
                    id="passenger-name-id"
                    name="passengerName"
                    maxLength={100}
                    value={rootStore.passengerStore.getPassengersName}
                    onChange={(event) => {
                      rootStore.passengerStore.handlePassengersName(event.target.value);
                    }}
                  />
                </FormField>

                <FormField className="add-passenger-form-F1">
                  <label className="add-passenger-form-L1">Passenger’s Age <span> *</span></label>
                  {/* <TextInput
                    type="number"
                    className="add-passenger-form-I2"
                    onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                    value={rootStore.passengerStore.getPassengerAge}
                    onChange={(e) => {
                      rootStore.passengerStore.handlePassengerAge(e.target.value);
                    }}
                    placeholder="Enter Here"
                  /> */}
                  <TextInput
                    type="number"
                    className="add-passenger-form-I2"
                    onKeyDown={handleAgeKeyDown}
                    onChange={handleAgeChange}
                    onPaste={handleAgePaste}
                    value={rootStore.passengerStore.getPassengerAge || ''}
                    placeholder="Enter Here"
                    maxLength={3}
                  />
                </FormField>
              </Box>
              <Box className='middle-form-flex'>
                {/* <FormField className="add-passenger-form-F1">
                  <label className="add-passenger-form-L1">Passenger’s Contact Number<span>*</span></label>
                  <TextInput type="number" className="add-passenger-form-I2"
                    value={rootStore.passengerStore.getPassengersContactNumber}
                    onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                    onChange={(e) => {
                      rootStore.passengerStore.handlePassengersContactNumber(e.target.value);
                    }}
                    placeholder="Enter Here" />
                </FormField> */}
                <FormField
                  className="add-passenger-form-F1"
                  name="email"
                  htmlFor="emailinput-id"
                  error={emailError || undefined} 
                >
                  <label className="add-passenger-form-L1">Passenger’s Email</label>
                  <TextInput type="email" className="add-passenger-form-I2"
                    id="emailinput-id"
                    maxLength={50}
                    value={rootStore.passengerStore.getPassengerEmail}
                    onChange={(event) => {
                      const value = event.target.value.trim(); // sanitize spaces
                      rootStore.passengerStore.handlePassengerEmail(value);

                      const emailRegex =
  /^(?!.*\.\.)(?!\.)([a-zA-Z0-9._%+-]+[a-zA-Z0-9_+-])@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;


                      if (value && !emailRegex.test(value)) {
                        setEmailError("Invalid email format.");
                      } else {
                        setEmailError('');
                      }
                    }}
                    placeholder="Enter Here" />
                </FormField>
              </Box>
              <FormField className="add-passenger-form-F1">
                <label className="add-passenger-form-L1">Passenger’s Address</label>
                <TextInput type="text" className="add-passenger-form-I2"

                  value={rootStore.passengerStore.getPassengerAddress}
                  maxLength={100}
                  onChange={(e) => {
                    rootStore.passengerStore.handlePassengerAddress(e.target.value);
                  }}
                  placeholder="Enter Here" />
              </FormField>
              </div>
                <Box className='add-passenger-footer'>
                    <Button className='footer-btn-1'
                    onClick={() => navigate("/passengers")}
                    >Cancel</Button>
                    <Button className='footer-btn-2'
                    primary label="Next"
                    onClick={ChangeStateForm}
                    />
                </Box>
            </Box>
          </Form>
        ) : (
          <></>
        )
      }
      {!rootStore.passengerStore.getChangeForm ? (
        <Form className='middle-container' onSubmit={onFormSubmit}>
          <Box className='middle-form2-box'>
            <FormField className="add-passenger-form2-F1">
              {/* Any Chronic Disease  */}
              <label className="add-passenger-form2-L1">Does the individual or their family have any chronic conditions like diabetes, hypertension, asthma, or heart disease?</label> 
              <div className="form-group">
                <div className="gender-options">
                  <Box style={{ display: "flex", flexDirection: "row", gap: "5px" }}>
                    <label style={{ color: "#333", fontFamily: "Inter", fontSize: "12px", fontWeight: "500", lineHeight: "16px" }}>
                      <input
                        style={{ width: "16px", height: "16px" }}
                        type="radio"
                        name='yes/no'
                        onChange={() => rootStore.passengerStore.handlePassengerAnyChronicDisease(true)}
                        checked={rootStore.passengerStore.getPassengerAnyChronicDisease}
                      />
                      Yes
                    </label>

                    <TextInput
                      className='placeholder-class'
                      style={{
                        color:" #A7B6D1",
                        fontFamily: "Inter",
                        fontSize: "14px",
                        fontStyle: "normal",
                        fontWeight: "300",
                        lineHeight: "22px",
                        background: "#F2F7FF",
                        border: "none",
                        width: "200px",
                        height: "48px",
                        padding: "12px 14px",
                        borderRadius: "10px",
                      }}
                      maxLength={100}
                      placeholder="Enter Here"
                      value={rootStore.passengerStore.getPassengerAnyChronicDisease1}
                      onChange={(e) => rootStore.passengerStore.handlePassengerAnyChronicDisease1(e.target.value)} // Handle input change
                      disabled={!rootStore.passengerStore.getPassengerAnyChronicDisease} // Disable input when No is selected
                    />
                  </Box>

                  <label style={{ color: "#333", fontFamily: "Inter", fontSize: "12px", fontWeight: "500", lineHeight: "16px" }}>
                    <input

                      style={{ width: "16px", height: "16px" }}
                      type="radio"
                      name='yes/no'
                      checked={!rootStore.passengerStore.getPassengerAnyChronicDisease}
                      onChange={() => {
                        rootStore.passengerStore.handlePassengerAnyChronicDisease(false); // Disable input when No
                        rootStore.passengerStore.handlePassengerAnyChronicDisease1(''); // Clear input if No
                      }}
                    />
                    No
                  </label>
                </div>
              </div>
            </FormField>

            <Box className='middle-form2-flex'>
              <FormField className="add-passenger-form2-F1">
                {/* Physically Disabled  */}
                <label className="add-passenger-form2-L1">Impaired</label>
                <div className="form-group">
                  <div className="gender-options">
                  <Box style={{ display: "flex", flexDirection: "row", gap: "5px" }}>
                    <label style={{
                      color: "#333",
                      fontFamily: "Inter",
                      fontSize: "12px",
                      fontStyle: "normal",
                      fontWeight: "500",
                      lineHeight: "16px"
                    }}>
                      <input
                        style={{ width: "16px", height: "16px" }}
                        type="radio"
                        name="physically-disabled"
                        checked={rootStore.passengerStore.getPassengerPhysicallyDisabled}
                        onChange={() => rootStore.passengerStore.handlePassengerPhysicallyDisabled(true)}
                      />
                      Yes
                    </label>
                    <TextInput
                      className='placeholder-class'
                      style={{
                        color:" #A7B6D1",
                        fontFamily: "Inter",
                        fontSize: "14px",
                        fontStyle: "normal",
                        fontWeight: "300",
                        lineHeight: "22px",
                        background: "#F2F7FF",
                        border: "none",
                        width: "200px",
                        height: "48px",
                        padding: "12px 14px",
                        borderRadius: "10px",
                      }}
                      maxLength={100}
                      placeholder="Enter Here"
                      value={rootStore.passengerStore.getPassengerPhysicallyDisabledtxt}
                      onChange={(e) => rootStore.passengerStore.handlePassengerPhysicallyDisabledtxt(e.target.value)} // Handle input change
                      disabled={!rootStore.passengerStore.getPassengerPhysicallyDisabled} // Disable input when No is selected
                    />
                    </Box>
                    <label style={{
                      color: "#333",
                      fontFamily: "Inter",
                      fontSize: "12px",
                      fontStyle: "normal",
                      fontWeight: "500",
                      lineHeight: "16px"
                    }}>
                      <input
                        style={{ width: "16px", height: "16px" }}
                        type="radio"
                        name="physically-disabled"
                        checked={!rootStore.passengerStore.getPassengerPhysicallyDisabled}
                        onChange={() => rootStore.passengerStore.handlePassengerPhysicallyDisabled(false)}

                      />
                      No
                    </label>
                  </div>
                </div>
              </FormField>


            </Box>
            <Box className='middle-form2-flex'
              style={{ marginTop: "10px" }}>
              <FormField className="add-passenger-form2-F1">
                {/* Are you currently taking any medications? */}
                <label className="add-passenger-form2-L1">Is the passenger currently taking any medications?</label>
                <div className="form-group">
                  <div className="gender-options">
                    <Box style={{ display: "flex", flexDirection: "row", gap: "5px" }}>
                      <label style={{ color: "#333", fontFamily: "Inter", fontSize: "12px", fontWeight: "500", lineHeight: "16px" }}>
                        <input
                          style={{ width: "16px", height: "16px", fontFamily: "Inter",color: '#41454B' }}
                          type="radio"
                          name="doc3"
                          checked={rootStore.passengerStore.getPassengerInput0}
                          onChange={() => rootStore.passengerStore.handlePassengerInput0(true)} // Enable input when Yes
                        />
                        Yes
                      </label>

                      <TextInput
                      className='placeholder-class'
                        required
                        style={{
                          border: "none",
                          width: "200px",
                          height: "48px",
                          padding: "12px 14px",
                          borderRadius: "10px",
                          background: "#F2F7FF",
                          color: "#A7B6D1",
                          fontFamily: "Inter",
                          fontSize: "12px",
                          fontWeight: "500",
                        }}
                        maxLength={100}
                        placeholder="Enter Here"
                        name="doc3"
                        type='text'
                        value={rootStore.passengerStore.getPassengerInput00}
                        onChange={(event) => rootStore.passengerStore.handlePassengerInput00(event.target.value)} // Handle input change
                        disabled={!rootStore.passengerStore.getPassengerInput0} // Disable if "No" is selected
                      />
                    </Box>

                    <label style={{ color: "#333", fontFamily: "Inter", fontSize: "12px", fontWeight: "500", lineHeight: "16px" }}>
                      <input

                        style={{ width: "16px", height: "16px" }}
                        type="radio"
                        name="doc3"
                        checked={!rootStore.passengerStore.getPassengerInput0}
                        onChange={() => {
                          rootStore.passengerStore.handlePassengerInput0(false);
                          rootStore.passengerStore.handlePassengerInput00('') // Disable input when No is selected
                        }}
                      />
                      No
                    </label>
                  </div>
                </div>
              </FormField>

            </Box>

            <Box className='middle-form2-flex'>
              <FormField className="add-passenger-form2-F1">
                <label className="add-passenger-form2-L1">Has the passenger recently been hospitalized for any serious illnesses, injuries, or surgeries? If so, when and why?</label>
                <TextInput type="text" className="add-passenger-form2-I3"
                  maxLength={100}
                  value={rootStore.passengerStore.getPassengerInput2}
                  onChange={(e) => rootStore.passengerStore.handlePassengerInput2(e.target.value)}
                  placeholder="Enter Here" />
              </FormField>

            </Box>

            <Box className='middle-form2-flex'>
              <FormField className="add-passenger-form2-F1">
                <label className="add-passenger-form2-L1">Does the passenger have any allergies to medications, foods, or other substances?</label>
                <TextInput type="text" className="add-passenger-form2-I3"
                  maxLength={100}
                  value={rootStore.passengerStore.getPassengerInput3}
                  onChange={(e) => rootStore.passengerStore.handlePassengerInput3(e.target.value)}
                  placeholder="Enter Here" />
              </FormField>

            </Box>
            <Box className='middle-form2-flex'>
              <FormField className="add-passenger-form2-F1">
                <label className="add-passenger-form2-L1">Has the passenger been diagnosed with COVID-19 in the past 6 months?</label>
                <div className="form-group">
                  <div className="gender-options">
                    <label style={{
                      color: "#333",
                      fontFamily: "Inter",
                      fontSize: "12px",
                      fontStyle: "normal",
                      fontWeight: "500",
                      lineHeight: "16px",
                    }}>
                      <input
                        style={{ width: "16px", height: "16px" }}
                        type="radio"
                        name='doc4'
                        onChange={() => rootStore.passengerStore.handlePassengerInput4("Yes")}
                        checked={rootStore.passengerStore.getPassengerInput4 === 'Yes'}
                      />
                      Yes
                    </label>
                    <label style={{
                      color: "#333",
                      fontFamily: "Inter",
                      fontSize: "12px",
                      fontStyle: "normal",
                      fontWeight: "500",
                      lineHeight: "16px",
                    }}>
                      <input
                        style={{ width: "16px", height: "16px" }}
                        type="radio"
                        name='doc4'
                        onChange={() => rootStore.passengerStore.handlePassengerInput4("No")}
                        checked={rootStore.passengerStore.getPassengerInput4 === 'No' || rootStore.passengerStore.getPassengerInput4 === ""}
                      />
                      No
                    </label>

                  </div>
                </div>

              </FormField>

            </Box>
            <Box className='middle-form2-flex'
              style={{ marginTop: "10px" }}>
              <FormField className="add-passenger-form2-F1">
                <label className="add-passenger-form2-L1">Does the passenger currently have any symptoms of illness, such as fever, cough, or shortness of breath?</label>
                <div className="form-group">
                  <div className="gender-options">
                    <Box style={{ display: "flex", flexDirection: "row", gap: "5px" }}>
                      <label style={{ color: "#333", fontFamily: "Inter", fontSize: "12px", fontWeight: "500", lineHeight: "16px" }}>
                        <input
                          style={{ width: "16px", height: "16px" }}
                          type="radio"
                          name='doc5'
                          checked={rootStore.passengerStore.getPassengerInput5}
                          onChange={() => rootStore.passengerStore.handlePassengerInput5(true)} // Enable input when Yes
                        />
                        Yes
                      </label>

                      <TextInput
                        required
                           className='placeholder-class'
                        style={{
                          border: "none",
                          width: "200px",
                          height: "48px",
                          padding: "12px 14px",
                          borderRadius: "10px",
                          background: "#F2F7FF",
                          color: "#A7B6D1",
                          fontFamily: "Inter",
                          fontSize: "12px",
                          fontWeight: "500",
                        }}
                        maxLength={100}
                        placeholder="Enter Details Here"
                        name='doc5'
                        value={rootStore.passengerStore.getPassengerInput05}
                        onChange={(e) => rootStore.passengerStore.handlePassengerInput05(e.target.value)} // Handle input change
                        disabled={!rootStore.passengerStore.getPassengerInput5} // Disable if "No" is selected
                      />
                    </Box>

                    <label style={{ color: "#333", fontFamily: "Inter", fontSize: "12px", fontWeight: "500", lineHeight: "16px" }}>
                      <input

                        style={{ width: "16px", height: "16px" }}
                        type="radio"
                        name='doc5'
                        checked={!rootStore.passengerStore.getPassengerInput5}
                        onChange={() => {
                          rootStore.passengerStore.handlePassengerInput5(false);
                          rootStore.passengerStore.handlePassengerInput05('') // Disable input when No is selected
                        }}
                      />
                      No
                    </label>
                  </div>
                </div>
              </FormField>

            </Box>
            <Box className='middle-form2-flex'
              style={{ marginTop: "10px" }}>
              <FormField className="add-passenger-form2-F1">
                {/* Do you have any other medical conditions or concerns we should be aware of? */}
                <label className="add-passenger-form2-L1">Does the passenger have any other medical conditions or concerns we should be aware of?</label>
                <div className="form-group">
                  <div className="gender-options">
                    <Box style={{ display: "flex", flexDirection: "row", gap: "5px" }}>
                      <label style={{ color: "#333", fontFamily: "Inter", fontSize: "12px", fontWeight: "500", lineHeight: "16px" }}>
                        <input
                          style={{ width: "16px", height: "16px" }}
                          type="radio"
                          name='doc6'
                          checked={rootStore.passengerStore.getPassengerInput6}
                          onChange={() => {
                            rootStore.passengerStore.handlePassengerInput6(true);
                            rootStore.passengerStore.handlePassengerInput06(''); // Reset input value
                          }}
                        />
                        Yes
                      </label>

                      <TextInput
                      className='placeholder-class'
                        style={{
                          border: "none",
                          width: "200px",
                          height: "48px",
                          padding: "12px 14px",
                          borderRadius: "10px",
                          background: "#F2F7FF",
                          color: "#A7B6D1",
                          fontFamily: "Inter",
                          fontSize: "12px",
                          fontWeight: "500",
                        }}
                        maxLength={100}
                        placeholder="Enter Details Here"
                        value={rootStore.passengerStore.getPassengerInput06}
                        onChange={(e) => rootStore.passengerStore.handlePassengerInput06(e.target.value)}
                        disabled={!rootStore.passengerStore.getPassengerInput6}
                      />
                    </Box>

                    <label style={{ color: "#333", fontFamily: "Inter", fontSize: "12px", fontWeight: "500", lineHeight: "16px" }}>
                      <input
                        style={{ width: "16px", height: "16px" }}
                        type="radio"
                        name='doc6'
                        checked={!rootStore.passengerStore.getPassengerInput6}
                        onChange={() => {
                          rootStore.passengerStore.handlePassengerInput6(false);
                          rootStore.passengerStore.handlePassengerInput06(''); // Reset input value
                        }}
                      />
                      No
                    </label>
                  </div>
                </div>
              </FormField>


            </Box>
            <Box className='add-passenger-footer'
            >
              <Button className='footer-btn-1'
                onClick={() => { rootStore.passengerStore.handlChangeForm(true) }}>Back</Button>
              <Button className='footer-btn-2' type="submit" label="Submit" />
            </Box>
          </Box>
        </Form>
      ) : (
        <></>
      )

      }







    </Box>
    </>
  )
})

export default AddPassengers

